import {httpRequest} from "../../..//utils/HttpRequest";
import {IPage} from "../../../types/FmsTypes";
import {IWarehouseParams,IWarehouseSearch,IWarehouseDetail,IWarehouseInsert,IWarehouseUpdata,IWarehouseDisable} from "./warehouseTypes"
class WarehouseService {
    async page(params:IWarehouseSearch){
        const apiUrl = "/md/warehouse/page"
        return await httpRequest.post<IPage<IWarehouseDetail>>(apiUrl,params)
    }
    async insert(params:IWarehouseInsert){
        const apiUrl = "/md/warehouse/insert"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async update(params:IWarehouseUpdata){
        const apiUrl = "/md/warehouse/update"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async disable(params:IWarehouseDisable){
        const apiUrl = "/md/warehouse/disable"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
}
const warehouseService = new WarehouseService()
export {
    warehouseService
}